import React, { useState } from 'react';
import { FaPaperPlane } from 'react-icons/fa';

const ChatComposer = ({ onSend, loading, busyElsewhere = false, autoFocus = false, inputId = 'chat-input' }) => {
    const [draft, setDraft] = useState('');

    const submit = () => {
        if (!draft.trim() || loading) {
            return;
        }
        onSend(draft);
        setDraft('');
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        submit();
    };

    const handleKeyDown = (event) => {
        // Enter sends, Shift+Enter adds a line - the usual chat convention.
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            submit();
        }
    };

    return (
        <form className="chat-composer" onSubmit={handleSubmit}>
            <label className="visually-hidden" htmlFor={inputId}>
                Ask a question
            </label>
            <textarea
                id={inputId}
                className="chat-input"
                rows={1}
                placeholder={
                    busyElsewhere
                        ? 'INNA is answering another conversation…'
                        : 'Ask about the catalogue, sales, availability…'
                }
                value={draft}
                onChange={(event) => setDraft(event.target.value)}
                onKeyDown={handleKeyDown}
                disabled={loading}
                autoFocus={autoFocus}
            />
            <button
                type="submit"
                className="btn btn-primary chat-send"
                disabled={loading || !draft.trim()}
                aria-label="Send message"
            >
                <FaPaperPlane className="fa-icon d-inline-block" />
            </button>
        </form>
    );
};

export default ChatComposer;
